import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { Notification } from "../../pages/Notifications/schema/notification";
import { notificationApi } from "./notification.api";

export interface NotificationState {
	unreadCount: number;
	notifications: Notification[];
	isPanelOpen: boolean;
}

const initialState: NotificationState = {
	unreadCount: 0,
	notifications: [],
	isPanelOpen: false,
};

export const notificationSlice = createSlice({
	name: "notification",
	initialState,
	reducers: {
		setUnreadCount: (state, { payload }: PayloadAction<number>) => {
			state.unreadCount = payload;
		},
		addRealtimeNotification: (state, { payload }: PayloadAction<Notification>) => {
			// Prepend new notification to the list (avoid duplicates)
			const exists = state.notifications.some((n) => n.id === payload.id);

			if (!exists) {
				state.notifications.unshift(payload);
			}
		},
		togglePanel: (state) => {
			state.isPanelOpen = !state.isPanelOpen;
		},
		openPanel: (state) => {
			state.isPanelOpen = true;
		},
		closePanel: (state) => {
			state.isPanelOpen = false;
		},
		clearNotifications: (state) => {
			state.notifications = [];
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			notificationApi.endpoints.getUnreadCount.matchFulfilled,
			(state, { payload }) => {
				state.unreadCount = payload.unreadCount;
			}
		);
		builder.addMatcher(
			notificationApi.endpoints.getNotifications.matchFulfilled,
			(state, { payload }) => {
				if (payload?.data) {
					state.notifications = payload.data;
				}
			}
		);
		builder.addMatcher(notificationApi.endpoints.markAllAsRead.matchFulfilled, (state) => {
			state.unreadCount = 0;
			state.notifications = state.notifications.map((n) => ({ ...n, isRead: true }));
		});
	},
});

export const {
	setUnreadCount,
	addRealtimeNotification,
	togglePanel,
	openPanel,
	closePanel,
	clearNotifications,
} = notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;
export const notificationSelector = (state: RootState) => state[notificationSlice.name];
